import ConfirmOrdersTable from "../../components/react-table/order-maintenance";

function ConfirmsOrdenesCompra() {
  return (
    <div>
      <ConfirmOrdersTable contextmenu="confirma" />
    </div>
  );
}

export default ConfirmsOrdenesCompra;
